import React from 'react';

import { formatPhoneNumber } from 'kb-shared/utilities/phones';
import {
  MEMBER_SERVICES_PHONE_NUMBER,
  memberServicesPhoneHref
} from 'screens/Book/memberServicesPhone';

// Without a phone (flag off) this keeps the original member services link markup.
export const MemberServicesPhoneLink = ({ phone }: { phone?: string }) =>
  phone ? (
    <a href={memberServicesPhoneHref(phone)}>{formatPhoneNumber(phone)}</a>
  ) : (
    <a href={`tel://${MEMBER_SERVICES_PHONE_NUMBER}`}>{MEMBER_SERVICES_PHONE_NUMBER}</a>
  );
